export const validatePrimaryDiamondFields = (filters) => {
  let fieldNames = [
    'primary_diamond_size',
    'colour'
  ]

  const fieldErrorMsgMapping = {
    'primary_diamond_size': 'Primary Diamond Size',
    'colour': 'Primary Diamond Colour',
    'primary_diamond_shape': 'Primary Diamond Shape'
  }

  let missingFields = fieldNames.filter((e) => { return filters[e] === null })
  // validate the prescence of primary diamond shape
  if (filters['shapes'].length === 0) {
    missingFields.push('primary_diamond_shape')
  }

  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/primary-diamond-fields/index.js